import { Button, Result } from "antd";
import { ISingleReservation, IWholeHallReservation, locale, t } from "../MainApp";
import { useNavigate } from "react-router-dom";

type ReservationMadeWindowProps = {
    onMakeAnotherReservation: () => void;
    reservation: ISingleReservation | undefined;
    wholeHallReservation?: IWholeHallReservation;
    locale: locale;
};

export function ReservationMadeWindow(props: ReservationMadeWindowProps) {

    let navigate = useNavigate();

    function goToMainSite() {
        navigate(`/`);
    }

    return (        
            <Result
                status="success" title={ props.reservation || props.wholeHallReservation ? 
                    t(props.locale, "reservationUpdated")
                    : 
                    t(props.locale, "reservationSaved")
                } extra={[
                    <div>
                        <Button type="primary" key="close" onClick={() => goToMainSite()}>
                            {t(props.locale, "returnToMainSite")}
                        </Button>
                        <Button key="makeAnother" onClick={() => props.onMakeAnotherReservation()}>{t(props.locale, "makeAnotherReservation")}</Button>
                    </div>
                ]} />
    );
}